import modalStyle from "./modal.module.scss";

import React, { useState, useEffect, memo } from 'react';
import { Typography } from "@mui/material";

import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";

const ModalDiscoveryError = (props) => {
  const { title, content, closeOpenModal, retryScanningDevices } = props;

  // State

  // Method

  // Side effect
  useEffect(() => {
  }, []);

  return (
    <>
      <div className={modalStyle['modal_Block']} style={{ margin: '20px 0' }}>
        <Typography color="#707ca8" fontWeight="600" fontSize="20px">
          {title}
        </Typography>
      </div>
      <div className={modalStyle['modal_Block']} style={{ margin: '20px 0' }}>
        <Typography fontSize="15px" color="rgba(0, 0, 0, 0.8)">
          {content}
        </Typography>
      </div >
      <div className={modalStyle['modal_operation']}>
        <OutlineButton
          className={modalStyle['modal_cancelBtn']}
          style={{ width: '195px', height: '42px', fontSize: '16px' }}
          variant="contained"
          onClick={closeOpenModal}
        >
          Cancel
        </OutlineButton>
        <SolidButton
          className={modalStyle['modal_saveBtn']}
          style={{ width: '195px', height: '42px', fontSize: '16px' }}
          variant="contained"
          onClick={retryScanningDevices}
        >
          Retry
        </SolidButton>
      </div>
    </>
  );
}

export default memo(ModalDiscoveryError);